import { Directive, ElementRef, HostListener, Renderer2, OnInit, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[appFloatingLabel]',
  standalone: false
})
export class FloatingLabelDirective implements OnInit, AfterViewInit {
  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
  }

  ngAfterViewInit() {
    // Initial check for value
    setTimeout(() => this.updateState(), 0);
  }

  @HostListener('focusin') onFocus() {
    this.renderer.addClass(this.el.nativeElement, 'active');
    this.renderer.addClass(this.el.nativeElement, 'focused');
  }

  @HostListener('focusout') onBlur() {
    this.renderer.removeClass(this.el.nativeElement, 'focused');
    this.updateState();
  }

  @HostListener('input') onInput() {
    this.updateState();
  }

  @HostListener('change') onChange() {
    this.updateState();
  }

  private updateState() {
    // Try to find common input/select elements within the host
    let input: any = this.el.nativeElement.querySelector('input, textarea, mat-select, .mat-select');

    // If not found directly, try inside a mat-form-field wrapper
    if (!input) {
      const matField = this.el.nativeElement.querySelector('mat-form-field');
      if (matField) {
        input = matField.querySelector('input, textarea, mat-select, .mat-select');
      }
    }

    let hasValue = false;

    if (input) {
      const tagName = (input.tagName || '').toUpperCase();
      const isMatSelect = tagName === 'MAT-SELECT' || input.classList && input.classList.contains('mat-select');

      if (isMatSelect) {
        // Check multiple possible trigger/value selectors used by different Angular Material versions
        const trigger = input.querySelector('.mat-select-value-text, .mat-select-value, .mat-mdc-select-value, .mat-select-trigger, .mat-select-placeholder, .mdc-select__selected-text');
        if (trigger && trigger.textContent) {
          const txt = trigger.textContent.trim();
          hasValue = txt.length > 0;
        } else {
          // As a fallback, check for a selected option element
          const selectedOption = input.querySelector('mat-option[aria-selected="true"], mat-option[selected]');
          if (selectedOption && selectedOption.textContent) {
            hasValue = selectedOption.textContent.trim().length > 0;
          }
        }
      } else {
        // For standard inputs/textareas, only treat as having value when non-empty
        try {
          const val = input.value;
          hasValue = val !== undefined && val !== null && String(val).trim().length > 0;
        } catch (e) {
          hasValue = false;
        }
      }

      if (hasValue || document.activeElement === input) {
        this.renderer.addClass(this.el.nativeElement, 'active');
      } else {
        this.renderer.removeClass(this.el.nativeElement, 'active');
      }
    }
  }
}
